<template>
  <div class="news-detail">
    <Header></Header>

    <div class="banner-bg">
      <div class="flex-col banner-title">
        <p class="main-title">中产资讯</p>
        <p class="sub-title">专业 · 精准 · 高效</p>
      </div>
    </div>
    <div class="container news-content flex-row">
      <div class="news-left flex-col">
        <h1>{{info.articleTitle}}</h1>
        <div class="label-share flex-row">
          <div class="label">
            <span class="tag">{{info.categoryText}}</span>
            <span class="time">{{info.publishTime&&info.publishTime.slice(0,10)}}</span>
          </div>
          <!-- 暂时隐藏分享 -->
          <!-- <div class="share">
            <span>
              <img src="@/assets/images/news/wc.png" alt="">
            </span>
            <span>
              <img src="@/assets/images/news/pyq.png" style="margin:0 10px;" alt="">
            </span>
            <span>
              <img src="@/assets/images/news/wb.png" alt="">
            </span>
          </div> -->
        </div>
        <div class="content" v-html="info.content">
          <!-- 预留 -->
        </div>
          <!-- 暂时隐藏分享 -->

        <!-- <div class="footer-share flex-row">
          <div class="flex-row share-way">
            <span>
              <img src="@/assets/images/news/wc.png" alt="">
            </span>
            <span style="margin:0 10px;">
              <img src="@/assets/images/news/pyq.png" alt="">
            </span>
            <span>
              <img src="@/assets/images/news/wb.png" alt="">
            </span>
          </div>
        </div> -->
        <div class="stripe"></div>
        <div class="change-page flex-row">
          <div class="prev flex-col" @click="toDetail(last.id)">
            <p class="handle ">
              <img src="@/assets/images/news/prev.png" alt="" style="marin-right:8px;">
              上一篇
            </p>
            <p class="desc">
              {{last.articleTitle}}
            </p>
          </div>
          <div class="next flex-col" @click="toDetail(next.id)">
            <p class="handle">
              下一篇
              <img src="@/assets/images/news/next.png" alt="" style="marin-left:8px;">
            </p>
            <p class="desc">
              {{next.articleTitle}}
            </p>
          </div>
        </div>
      </div>
      <div class="news-right flex-col">
        <div class="title flex-row">
          <span class="tag-line"></span>
          <span>资讯推荐</span>
        </div>
        <div class="list flex-col">
          <div @click="toDetail(v.id)" class="item" v-for="(v,i) in recommendList" :key="i">
            <img :src="v.thumb&&v.thumb[0]" alt="">
            <p class="desc breviary">{{v.articleTitle}}</p>
            <p class="time">{{v.publishTime&&v.publishTime.slice(0,10)}}</p>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>

  </div>
</template>

<script>
import '@/assets/css/news-detail.css'
import { timestampToTime } from '@/assets/js'
import Header from './Header'
import Footer from './Footer'
export default {
  name: 'News',
  components: {
    Header, Footer
  },
  data () {
    return {
      info: {
        category: "新闻动态",
        publishTime: '',
        articleTitle: "招商风向标 | 2021中国“潜在独角兽企业报告”发布，425家企业名单出炉！",
        prevDesc: "正式落地 | 仅用1个月！中产集团成功助力新一代信息技术产品生产项目落地重庆某合作政府并高效注册公司",
        nextDesc: "园区推荐 | 多重政策利好！宿州经开区以生物医药产业为首位打造经济发展新引擎"
      },
      last:{
        articleTitle:'',
      },
      next:{
        articleTitle:'',
      },
      recommendList:[]
    }
  },
  mounted(){
    this.id=this.$route.query.id?this.$route.query.id:sessionStorage.getItem('id')
    sessionStorage.setItem('id',this.id)
    sessionStorage.setItem('headCurrent','中产资讯')
    this.getDetail()
  },
  methods: {
    getDetail(){//资讯内容
      
      this.Axios.get(`/api/index/cms/article/info/${this.id}`).then(res=>{
        this.info=res.data.data
        document.documentElement.scrollTop = 650;
        this.getBeforeAfter()
        this.getRecommend()
      })
    },
    toDetail(id){//打开其他文章
      this.id=id
      this.getDetail()
      sessionStorage.setItem('id',this.id)
    },
    getBeforeAfter(){//获取上下篇文章
      this.Axios.post(`/api/index/cms/article/pageControl`,{id:this.id}).then(res=>{
        this.last=res.data.data.last
        this.next=res.data.data.next
      })
    },
    getRecommend(){//推荐
      this.Axios.post(`/api/index/cms/article/recommend?currPage=1&size=5`,{id:this.id}).then(res=>{
        this.recommendList=res.data.data
      })
    },
    // 格式化时间
    formatDateLong (time) {
      return timestampToTime(time)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/NewsDetail.vue